// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signInButtonInline {
  display: inline-block;
}

.signInButtonInlineFull {
  display: inline-block;
  width: 100%;
}

.headerWrapper {
  width: 100%;
  height: 80px;
}
@media (max-width: 768px) {
  .headerWrapper {
    height: 74px;
  }
  .headerWrapper.axisSubdomain {
    height: 60px;
  }
}
.headerWrapper .headerContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  background-color: #FFFFFF;
  box-shadow: 0 0 2px 0px #808080;
  height: auto;
  min-height: 80px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer {
    height: 74px;
    min-height: 74px;
  }
}
.headerWrapper .headerContainer .headerBackgroundImage {
  width: 100%;
  height: 80px;
  display: block;
  position: relative;
}
.headerWrapper .headerContainer .axisSvg {
  position: absolute;
  top: 0;
  z-index: 11;
  width: 100%;
}
.headerWrapper .headerContainer .axisSvg .linkContainer {
  display: inline-block;
  width: 300px;
  position: absolute;
  z-index: 13;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .axisSvg .linkContainer {
    width: 200px;
  }
}
.headerWrapper .headerContainer .axisSvg .axisPathway {
  position: absolute;
  top: 0;
  width: 100%;
  height: 26px;
  z-index: 12;
  background-color: var(--theme-default-text-color);
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .axisSvg .axisPathway {
    height: 17.5px;
  }
}
.headerWrapper .headerContainer .headerContentOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}
.headerWrapper .headerContainer .headerContentOverlay .pathwaySection {
  position: relative;
  left: 0;
  right: 0;
  top: 4px;
  height: 80px;
  z-index: 10;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 1200px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerContentOverlay .pathwaySection {
    height: 60px;
  }
}
.headerWrapper .headerContainer .headerContentOverlay .pathwaySection .pathwaySearch {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 0;
}
.headerWrapper .headerContainer .headerContentOverlay .pathwaySection .pathwaySearch .pathwaySearchBlock {
  display: block;
  position: relative;
  min-width: 18px;
  height: 18px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerContentOverlay .pathwaySection .pathwaySearch .pathwaySearchBlock {
    min-width: 16px;
    height: 16px;
  }
}
.headerWrapper .headerContainer .headerContentOverlay .pathwaySection .pathwaySearch .pathwaySearchBlock .image {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerContentOverlay .pathwaySection .pathwaySearch .pathwaySearchBlock .image {
    width: 16px;
    height: 16px;
  }
}
.headerWrapper .headerContainer .headerBoxContainer {
  height: 80px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headerWrapper .headerContainer .headerBoxContainer.axisSubdomain {
  justify-content: flex-end;
  height: 105px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerBoxContainer.axisSubdomain {
    height: 60px;
  }
}
.headerWrapper .headerContainer .headerBoxContainer .linkContainer {
  display: flex;
  align-items: center;
  max-width: 300px;
  max-height: 80px;
  width: auto;
  height: auto;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerBoxContainer .linkContainer {
    max-width: 150px;
    max-height: 60px;
  }
}
.headerWrapper .headerContainer .headerBoxContainer .linkContainer .image {
  max-width: 300px;
  max-height: 80px;
  width: auto;
  height: auto;
  cursor: pointer;
  object-fit: contain;
  display: block;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerBoxContainer .linkContainer .image {
    max-width: 150px;
    max-height: 60px;
  }
}
.headerWrapper .headerContainer .headerBoxContainer .headerTabSection {
  display: flex;
  align-items: center;
  gap: 16px;
}
.headerWrapper .headerContainer .headerBoxContainer .headerTabSection .publicPage {
  display: block;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerBoxContainer .headerTabSection .publicPage {
    display: none;
  }
}
.headerWrapper .headerContainer .headerBoxContainer .headerTabSection .imageBlock {
  display: block;
  position: relative;
  min-width: 16px;
  height: 16px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerBoxContainer .headerTabSection .imageBlock {
    display: none;
  }
}
.headerWrapper .headerContainer .headerBoxContainer .headerTabSection .imageBlock .image {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.headerWrapper .headerContainer .headerBoxContainer .headerTabSection .privateBlock {
  display: block;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerBoxContainer .headerTabSection .privateBlock {
    display: none;
  }
}
.headerWrapper .headerContainer .headerBoxContainer .headerTabSection .publicSupport {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: var(--theme-default-text-color);
}
.headerWrapper .headerContainer .headerBoxContainer .headerTabSection .publicSupport .supportText {
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .headerBoxContainer .headerTabSection .publicSupport .supportText {
    display: none;
  }
  .headerWrapper .headerContainer .headerBoxContainer .headerTabSection .axissaMobile {
    margin-top: 20px;
  }
}
.headerWrapper .headerContainer .mobileSearchBarSection {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 0;
  margin-top: 8px;
  padding: 0 20px;
}
.headerWrapper .headerContainer .mobileSearchBarSection.flexBox {
  display: flex;
}
.headerWrapper .headerContainer .mobileSearchBarSection.hiddenBox {
  display: none;
}
.headerWrapper .headerContainer .mobileMenuSection {
  position: absolute;
  top: 0;
  z-index: 20;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  margin: 0 auto;
  margin-top: 75px;
  width: 100%;
  display: none;
  background-color: #FFFFFF;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .mobileMenuSection {
    display: block;
  }
}
.headerWrapper .headerContainer .mobileMenuSection.showMobile {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
}
.headerWrapper .headerContainer .mobileMenuSection.hiddenMobile {
  display: none;
}
.headerWrapper .headerContainer .mobileMenuSection .menuSection {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px;
}
.headerWrapper .headerContainer .mobileMenuSection .menuSection .menuItem {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.headerWrapper .headerContainer .mobileMenuSection .menuSection .menuItem .menuText {
  font-weight: 500;
  width: 100%;
  height: 40px;
  border-radius: 4px;
}
.headerWrapper .headerContainer .mobileViewHeaderOption {
  display: none;
  gap: 16px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .mobileViewHeaderOption {
    display: flex;
  }
}
.headerWrapper .headerContainer .mobileViewHeaderOption .headerMenuSection {
  background-color: #F7F7F7;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 9px;
  border-radius: 6px;
  cursor: pointer;
}
.headerWrapper .headerContainer .mobileViewHeaderOption .headerMenuSection svg {
  width: 18px;
  height: 18px;
}
.headerWrapper .headerContainer .mobileViewHeaderOption .menuOption {
  width: 36px;
  height: 36px;
  padding: 9px;
  border-radius: 6px;
  cursor: pointer;
  background-color: var(--theme-default-text-color);
}
.headerWrapper .headerContainer .mobileViewHeaderOption .menuOption svg {
  width: 18px;
  height: 18px;
}
.headerWrapper .headerContainer .mobileViewHeaderOption .mobileAuthEntry {
  display: flex;
  align-items: center;
}
.headerWrapper .headerContainer .mobileViewHeaderOption .mobileAuthButton {
  min-width: 70px;
  height: 36px;
  padding: 0 4px;
  border-radius: 6px;
  font-size: 14px;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .axissaMobile {
    margin-top: 20px;
    gap: 10px;
  }
  .headerWrapper .headerContainer .axissaMobile .headerMenuSection {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    padding: 6px;
  }
  .headerWrapper .headerContainer .axissaMobile .headerMenuSection svg {
    width: 16px;
    height: 16px;
  }
  .headerWrapper .headerContainer .axissaMobile .menuOption {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    padding: 6px;
  }
  .headerWrapper .headerContainer .axissaMobile .menuOption svg {
    width: 16px;
    height: 16px;
  }
}
.headerWrapper .headerContainer .authenticatedWebViewOption {
  display: flex;
  gap: 14px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .authenticatedWebViewOption {
    display: none;
  }
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody {
  background-color: #F7F7F7;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  font-size: 18px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  border: 1px solid #e2e8f0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-user-select: none;
          user-select: none;
  width: 308px;
  padding: 16px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px 20px;
  }
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .imageContainer {
  display: flex;
  flex-direction: column;
  text-wrap: wrap;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .imageContainer .font_600 {
  color: var(--theme-default-text-color);
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .profileDropdown {
  padding: 0;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-weight: 600;
  font-size: 16px;
  padding: 24px;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer {
    gap: 16px;
    padding: 24px 20px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .showTabModule {
  display: none;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .showTabModule {
    display: block;
  }
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .bodyContainer {
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  position: relative;
  border-radius: 10px;
  display: none;
}
@media (max-width: 768px) {
  .headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .bodyContainer {
    display: flex;
  }
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .bodyContainer .image {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .bodyContainer .cardHeader {
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .bodyContainer .showDropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 50;
  margin-top: 8px;
  width: 100%;
  height: 175px;
  overflow-y: auto;
  background-color: #ffffff;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .bodyContainer .showDropdown .cardItem {
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .bodyContainer .showDropdown .cardItem:hover {
  background-color: #F7F7F7;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .loyaltyPoint {
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  padding-right: 16px;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .dropDownBody .dropDownBodyContainer .logout:hover {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  cursor: pointer;
}
.headerWrapper .headerContainer .authenticatedWebViewOption.showAuthenticated {
  width: 35px;
  height: 35px;
}
.headerWrapper .headerContainer .authenticatedWebViewOption.showAuthenticated .header {
  width: 35px;
  height: 35px;
}
.headerWrapper .headerContainer .authenticatedWebViewOption.hideAuthenticated {
  width: auto;
}
.headerWrapper .headerContainer .authenticatedWebViewOption .buttonText {
  height: auto;
  width: auto;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
}
.headerWrapper .dropDownBody {
  background-color: #F7F7F7;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  font-size: 18px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  border: 1px solid #e2e8f0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-user-select: none;
          user-select: none;
  width: 308px;
  padding: 16px;
}
@media (max-width: 768px) {
  .headerWrapper .dropDownBody {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px 20px;
  }
}
.headerWrapper .dropDownBody .imageContainer {
  display: flex;
  flex-direction: column;
  text-wrap: wrap;
}
.headerWrapper .dropDownBody .imageContainer .font_600 {
  color: var(--theme-default-text-color);
}
.headerWrapper .dropDownBody .profileDropdown {
  padding: 0;
}
.headerWrapper .dropDownBodyContainer {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-weight: 600;
  font-size: 16px;
  padding: 24px;
}
@media (max-width: 768px) {
  .headerWrapper .dropDownBodyContainer {
    gap: 12px;
    padding: 20px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    font-size: 14px;
  }
}
.headerWrapper .dropDownBodyContainer .showTabModule {
  display: none;
}
@media (max-width: 768px) {
  .headerWrapper .dropDownBodyContainer .showTabModule {
    display: block;
  }
}
.headerWrapper .dropDownBodyContainer .bodyContainer {
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  position: relative;
  border-radius: 10px;
  display: none;
}
@media (max-width: 768px) {
  .headerWrapper .dropDownBodyContainer .bodyContainer {
    display: flex;
  }
}
.headerWrapper .dropDownBodyContainer .bodyContainer .image {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.headerWrapper .dropDownBodyContainer .bodyContainer .cardHeader {
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.headerWrapper .dropDownBodyContainer .bodyContainer .showDropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 50;
  margin-top: 8px;
  width: 100%;
  height: 90px;
  overflow-y: auto;
  background-color: #ffffff;
}
@media (max-width: 768px) {
  .headerWrapper .dropDownBodyContainer .bodyContainer .showDropdown {
    height: 75px;
    border-radius: 12px;
  }
}
.headerWrapper .dropDownBodyContainer .bodyContainer .showDropdown .cardItem {
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}
.headerWrapper .dropDownBodyContainer .bodyContainer .showDropdown .cardItem:hover {
  background-color: #F7F7F7;
}
.headerWrapper .dropDownBodyContainer .loyaltyPoint {
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  padding-right: 16px;
}
.headerWrapper .dropDownBodyContainer .offlineCacheButton {
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  padding: 0;
  text-align: left;
}
.headerWrapper .dropDownBodyContainer .offlineCacheButton:hover {
  text-decoration: underline;
}
.headerWrapper .dropDownBodyContainer .logout:hover {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  cursor: pointer;
}
.headerWrapper .loginComponentWrapper {
  max-width: 1200px;
  padding: 0 20px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .headerWrapper .loginComponentWrapper {
    justify-content: center;
  }
}
.headerWrapper .loginComponentWrapper .authDrawerContainer {
  position: absolute;
  top: 80px;
  z-index: 30;
  max-width: 448px;
  max-height: calc(100vh - 104px);
  margin-left: auto;
  margin-right: auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  width: 100%;
}
@media (max-width: 768px) {
  .headerWrapper .loginComponentWrapper .authDrawerContainer {
    max-width: calc(100vw - 0px);
    left: 0px;
    right: 0px;
  }
}
.headerWrapper .signUpComponentWrapper {
  margin-top: 8px;
  padding: 0 20px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .headerWrapper .signUpComponentWrapper {
    justify-content: center;
  }
}
.headerWrapper .signUpComponentWrapper .signUpContainer {
  position: absolute;
  z-index: 30;
  max-width: 448px;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 768px) {
  .headerWrapper .signUpComponentWrapper .signUpContainer {
    max-width: 768px;
  }
}

.tabModuleSection {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
}
@media (max-width: 768px) {
  .tabModuleSection {
    gap: 10px;
    flex-direction: column;
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
.tabModuleSection .animatePulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  height: 40px;
  width: 80px;
  background-color: #F7F7F7;
  border-radius: 8px;
}
.tabModuleSection .moduleTabButton {
  padding: 4px 8px;
  width: -webkit-max-content;
  width: max-content;
  cursor: pointer;
  border-radius: 4px;
  background-color: var(--moduleTabButtonBackground);
  color: var(--moduleTabButtonColor);
  border-color: var(--moduleTabButtonBorderColor);
}

.dropdownHeaderWrapper {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: #F7F7F7;
  padding: 4px 8px;
  border-radius: 4px;
  gap: 8px;
  position: relative;
  cursor: pointer;
}
@media (max-width: 768px) {
  .dropdownHeaderWrapper {
    display: none;
  }
}
.dropdownHeaderWrapper .headerDropdown {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdownHeaderWrapper .headerDropdown .headerDropdownLogo {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.dropdownHeaderWrapper .headerDropdown .headerText {
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-size: 12px;
  font-weight: 500;
}
@media (max-width: 1200px) {
  .dropdownHeaderWrapper .headerDropdown .headerText {
    font-size: 10px;
  }
}

.dropdownBody {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 50;
  margin-top: 8px;
  width: 100%;
  max-height: 110px;
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
}
.dropdownBody .cardInfo {
  padding: 8px;
  font-size: 12px;
  cursor: pointer;
}
.dropdownBody .cardInfo:hover {
  background-color: #F7F7F7;
}`, "",{"version":3,"sources":["webpack://./src/Components/CommonComponents/Header/Header.scss","webpack://./src/Styles/_mixins.scss","webpack://./src/Styles/_colors.scss","webpack://./src/Styles/_breakpoints.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,WAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;ACAE;EDFF;IAKI,YAAA;EACF;EAEA;IAEI,YAAA;EACJ;AAJF;AAOE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,yBEZO;EFaP,+BAAA;EACA,YAAA;EACA,gBAAA;AAAJ;ACtBE;EDYA;IAaI,YAAA;IACA,gBAAA;EACJ;AACF;AACI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AACN;AAMI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;AAJN;AAKM;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAHR;AC9CE;ED6CI;IAOI,YAAA;EAFR;AACF;AAKM;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iDAAA;AAHR;AC3DE;EDwDI;IASI,cAAA;EAFR;AACF;AAMI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EAEA,WAAA;AALN;AAOM;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AALR;ACtFE;ED8EI;IAgBI,YAAA;EAJR;AACF;AAMQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AAJV;AAMU;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAJZ;ACvGE;EDuGQ;IAOI,eAAA;IACA,YAAA;EAHZ;AACF;AAKY;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAHd;AClHE;EDkHU;IAMI,WAAA;IACA,YAAA;EAFd;AACF;AASI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAPN;AASM;EACE,yBAAA;EACA,aAAA;AAPR;ACtIE;ED2II;IAKI,YAAA;EANR;AACF;AASM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAPR;ACnJE;EDoJI;IASI,gBAAA;IACA,gBAAA;EANR;AACF;AAQQ;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AANV;AClKE;EDiKM;IAUI,gBAAA;IACA,gBAAA;EALV;AACF;AASM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAPR;AASQ;EACE,cAAA;AAPV;AChLE;EDsLM;IAII,aAAA;EANV;AACF;AASQ;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAPV;AC3LE;ED8LM;IAOI,aAAA;EANV;AACF;AAQU;EACE,WAAA;EACA,YAAA;EACA,eAAA;AANZ;AAUQ;EACE,cAAA;AARV;ACxME;ED+MM;IAII,aAAA;EAPV;AACF;AAUQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,sCAAA;AARV;AAcU;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EAAA,qDAAA;AAZZ;ACzNE;EDkOQ;IAMI,aAAA;EAXZ;EAgBM;IAEI,gBAAA;EAbV;AAJF;AAuBI;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AAhBN;AAkBM;EACE,aAAA;AAhBR;AAmBM;EACE,aAAA;AAjBR;AAqBI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,gCAAA;EAAA,qDAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,yBExQK;EFyQL,wCAAA;AAnBN;AC7PE;EDsQE;IAaI,cAAA;EAlBN;AACF;AAoBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAlBR;AAqBM;EACE,aAAA;AAnBR;AAsBM;EACE,iBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AApBR;AAsBQ;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AApBV;AAsBU;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AApBZ;AA0BI;EACE,aAAA;EACA,SAAA;AAxBN;AClSE;EDwTE;IAKI,aAAA;EAvBN;AACF;AAyBM;EACE,yBExTU;EFyTV,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAvBR;AAyBQ;EACE,WAAA;EACA,YAAA;AAvBV;AA2BM;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;AAzBR;AA2BQ;EACE,WAAA;EACA,YAAA;AAzBV;AA6BM;EACE,aAAA;EACA,mBAAA;AA3BR;AA8BM;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AA5BR;AC9UE;ED8WE;IAEI,gBAAA;IACA,SAAA;EA9BN;EAgCM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;EA9BR;EAgCQ;IACE,WAAA;IACA,YAAA;EA9BV;EAkCM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;EAhCR;EAkCQ;IACE,WAAA;IACA,YAAA;EAhCV;AACF;AAqCI;EACE,aAAA;EACA,SAAA;AAnCN;AC5WE;ED6YE;IAKI,aAAA;EAlCN;AACF;AAoCM;EACE,yBE7YU;EF8YV,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;EAAA,qDAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;EACA,aAAA;AAlCR;AClYE;EDqZI;IAkBI,WAAA;IACA,iBAAA;IACA,cAAA;IACA,kBAAA;EAjCR;AACF;AAmCQ;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAjCV;AAmCU;EACE,sCAAA;AAjCZ;AAqCQ;EACE,UAAA;AAnCV;AAsCQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gCAAA;EAAA,qDAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AApCV;AC9ZE;ED2bM;IAUI,SAAA;IACA,kBAAA;IACA,WAAA;IACA,iBAAA;IACA,cAAA;EAnCV;AACF;AAqCU;EACE,aAAA;AAnCZ;AC1aE;ED4cQ;IAII,cAAA;EAlCZ;AACF;AAqCU;EACE,uBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAnCZ;ACvbE;EDodQ;IASI,aAAA;EAlCZ;AACF;AAoCY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAlCd;AAqCY;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAnCd;AAsCY;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBE/fA;AF2dd;AAsCc;EACE,YAAA;EACA,eAAA;EACA,eAAA;AApChB;AAsCgB;EACE,yBEtfA;AFkdlB;AA0CU;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAxCZ;AA2CU;EACE,+BAAA;EACA,gCAAA;EACA,eAAA;AAzCZ;AA8CM;EACE,WAAA;EACA,YAAA;AA5CR;AA8CQ;EACE,WAAA;EACA,YAAA;AA5CV;AAgDM;EACE,WAAA;AA9CR;AAiDM;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/CR;AAoDE;EACE,yBEriBc;EFsiBd,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;EAAA,qDAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;EACA,aAAA;AAlDJ;AC1gBE;ED6iBA;IAkBI,WAAA;IACA,iBAAA;IACA,cAAA;IACA,kBAAA;EAjDJ;AACF;AAmDI;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAjDN;AAmDM;EACE,sCAAA;AAjDR;AAqDI;EACE,UAAA;AAnDN;AAuDE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gCAAA;EAAA,qDAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AArDJ;ACtiBE;EDolBA;IAUI,SAAA;IACA,aAAA;IACA,WAAA;IACA,iBAAA;IACA,cAAA;IACA,eAAA;EApDJ;AACF;AAsDI;EACE,aAAA;AApDN;ACnjBE;EDsmBE;IAII,cAAA;EAnDN;AACF;AAsDI;EACE,uBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AApDN;AChkBE;ED8mBE;IASI,aAAA;EAnDN;AACF;AAqDM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAnDR;AAsDM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AApDR;AAuDM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBEzpBM;AFomBd;AC5lBE;EDwoBI;IAYI,YAAA;IACA,mBAAA;EApDR;AACF;AAsDQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AApDV;AAsDU;EACE,yBEtpBM;AFkmBlB;AA0DI;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAxDN;AA2DI;EACE,uBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AAzDN;AA4DI;EACE,0BAAA;AA1DN;AA6DI;EACE,+BAAA;EACA,gCAAA;EACA,eAAA;AA3DN;AAgEE;EACE,iBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AA9DJ;AC5oBE;EDosBA;IASI,uBAAA;EA7DJ;AACF;AA+DI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,wBAAA;EACA,WAAA;AA7DN;AC9pBE;EDgtBE;IAcI,4BAAA;IACA,SAAA;IACA,UAAA;EA5DN;AACF;AAiEE;EACE,eAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AA/DJ;AC7qBE;EDsuBA;IASI,uBAAA;EA9DJ;AACF;AAgEI;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA9DN;ACzrBE;EDkvBE;IAQI,gBGjwBQ;EHosBd;AACF;;AAkEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA/DF;ACrsBE;EDgwBF;IAOI,SAAA;IACA,sBAAA;EA9DF;AACF;AAgEE;EACE;IACE,YAAA;EA9DJ;AACF;AAgEE;EACE,yDAAA;EACA,YAAA;EACA,WAAA;EACA,yBE3wBc;EF4wBd,kBAAA;AA9DJ;AAiEE;EACE,gBAAA;EACA,0BAAA;EAAA,kBAAA;EACA,eAAA;EAEA,kBAAA;EACA,kDAAA;EACA,kCAAA;EACA,+CAAA;AAhEJ;;AAuEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBEnyBgB;EFoyBhB,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AApEF;AC7uBE;EDuyBF;IAaI,aAAA;EAnEF;AACF;AAqEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnEJ;AAqEI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAnEN;AAsEI;EACE,gCAAA;EAAA,qDAAA;EACA,eAAA;EACA,gBAAA;AApEN;ACnvBE;EDozBE;IAMI,eAAA;EAnEN;AACF;;AAwEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBEn2BY;EFo2BZ,yBAAA;EACA,kBAAA;EACA,yEAAA;AArEF;AAuEE;EACE,YAAA;EACA,eAAA;EACA,eAAA;AArEJ;AAuEI;EACE,yBE71BY;AFwxBlB","sourcesContent":["@import \"src/Styles/theme.scss\";\n.signInButtonInline {\n  display: inline-block;\n}\n\n.signInButtonInlineFull {\n  display: inline-block;\n  width: 100%;\n}\n\n.headerWrapper {\n  width: 100%;\n  height: 80px;\n\n  @include respond-md {\n    height: 74px;\n  }\n\n  &.axisSubdomain {\n    @include respond-md {\n      height: 60px;\n    }\n  }\n\n  .headerContainer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    z-index: 1000;\n    background-color: $bg-white;\n    box-shadow: 0 0 2px 0px $color-primary-light-grey;\n    height: auto;\n    min-height: 80px;\n\n    @include respond-md {\n      height: 74px;\n      min-height: 74px;\n    }\n\n    .headerBackgroundImage {\n      width: 100%;\n      height: 80px;\n      display: block;\n      position: relative;\n\n      // @include respond-md {\n      //   height: 60px;\n      // }\n    }\n\n    .axisSvg {\n      position: absolute;\n      top: 0;\n      z-index: 11;\n      width: 100%;\n      .linkContainer {\n        display: inline-block;\n        width: 300px;\n        position: absolute;\n        z-index: 13;\n  \n        @include respond-md {\n          width: 200px;\n        }\n      }\n\n      .axisPathway {\n        position: absolute;\n        top: 0;\n        width: 100%;\n        height: 26px;\n        z-index: 12;\n        background-color: var(--theme-default-text-color);\n  \n        @include respond-md {\n          height: 17.5px;\n        }\n      }\n    }\n\n    .headerContentOverlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      // height: 100%;\n      z-index: 10;\n\n      .pathwaySection {\n        position: relative;\n        left: 0;\n        right: 0;\n        top: 4px;\n        height: 80px;\n        z-index: 10;\n        width: 100%;\n        padding: 0 20px;\n        margin: 0 auto;\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        max-width: 1200px;\n\n        @include respond-md {\n          height: 60px;\n        }\n\n        .pathwaySearch {\n          display: flex;\n          align-items: center;\n          gap: 20px;\n          margin-top: 0;\n\n          .pathwaySearchBlock {\n            display: block;\n            position: relative;\n            min-width: 18px;\n            height: 18px;\n            \n            @include respond-md {\n              min-width: 16px;\n              height: 16px;\n            }\n\n            .image {\n              width: 18px;\n              height: 18px;\n              cursor: pointer;\n              \n              @include respond-md {\n                width: 16px;\n                height: 16px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .headerBoxContainer {\n      height: 80px;\n      width: 100%;\n      max-width: 1200px;\n      margin: 0 auto;\n      padding: 0 20px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      &.axisSubdomain {\n        justify-content: flex-end;\n        height: 105px;\n\n        @include respond-md {\n          height: 60px;\n        }\n      }\n\n      .linkContainer {\n        display: flex;\n        align-items: center;\n        max-width: 300px;\n        max-height: 80px;\n        width: auto;\n        height: auto;\n\n        @include respond-md {\n          max-width: 150px;\n          max-height: 60px;\n        }\n\n        .image {\n          max-width: 300px;\n          max-height: 80px;\n          width: auto;\n          height: auto;\n          cursor: pointer;\n          object-fit: contain;\n          display: block;\n\n          @include respond-md {\n            max-width: 150px;\n            max-height: 60px;\n          }\n        }\n      }\n\n      .headerTabSection {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n\n        .publicPage {\n          display: block;\n\n          @include respond-md {\n            display: none;\n          }\n        }\n\n        .imageBlock {\n          display: block;\n          position: relative;\n          min-width: 16px;\n          height: 16px;\n\n          @include respond-md {\n            display: none;\n          }\n\n          .image {\n            width: 16px;\n            height: 16px;\n            cursor: pointer;\n          }\n        }\n\n        .privateBlock {\n          display: block;\n\n          @include respond-md {\n            display: none;\n          }\n        }\n\n        .publicSupport {\n          display: flex;\n          align-items: center;\n          gap: 4px;\n          cursor: pointer;\n          color: var(--theme-default-text-color);\n\n          @include respond-md {\n            // display: none;\n          }\n\n          .supportText {\n            font-size: 16px;\n            font-weight: 500;\n            font-family: var(--primary-font, 'Inter', sans-serif);\n\n            @include respond-md {\n              display: none;\n            }\n          }\n        }\n\n        .axissaMobile {\n          @include respond-md {\n            margin-top: 20px;\n          }\n        }\n      }\n    }\n\n    .mobileSearchBarSection {\n      max-width: 1200px;\n      margin: 0 auto;\n      position: relative;\n      z-index: 0;\n      margin-top: 8px;\n      padding: 0 20px;\n\n      &.flexBox {\n        display: flex;\n      }\n\n      &.hiddenBox {\n        display: none;\n      }\n    }\n\n    .mobileMenuSection {\n      position: absolute;\n      top: 0;\n      z-index: 20;\n      font-family: var(--primary-font, 'Inter', sans-serif);\n      margin: 0 auto;\n      margin-top: 75px;\n      width: 100%;\n      display: none;\n      background-color: $bg-white;\n      box-shadow: 0 4px 8px $color-border;\n\n      @include respond-md {\n        display: block;\n      }\n\n      &.showMobile {\n        display: flex;\n        flex-direction: column;\n        border-radius: 20px;\n      }\n\n      &.hiddenMobile {\n        display: none;\n      }\n\n      .menuSection {\n        max-width: 1200px;\n        margin: 0 auto;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n        padding: 16px 20px;\n\n        .menuItem {\n          display: flex;\n          justify-content: space-between;\n          gap: 20px;\n\n          .menuText {\n            font-weight: 500;\n            width: 100%;\n            height: 40px;\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n\n    .mobileViewHeaderOption {\n      display: none;\n      gap: 16px;\n\n      @include respond-md {\n        display: flex;\n      }\n\n      .headerMenuSection {\n        background-color: $bg-light-grey-2;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 36px;\n        height: 36px;\n        padding: 9px;\n        border-radius: 6px;\n        cursor: pointer;\n\n        svg {\n          width: 18px;\n          height: 18px;\n        }\n      }\n\n      .menuOption {\n        width: 36px;\n        height: 36px;\n        padding: 9px;\n        border-radius: 6px;\n        cursor: pointer;\n        background-color: var(--theme-default-text-color);\n\n        svg {\n          width: 18px;\n          height: 18px;\n        }\n      }\n\n      .mobileAuthEntry {\n        display: flex;\n        align-items: center;\n      }\n\n      .mobileAuthButton {\n        min-width: 70px;\n        height: 36px;\n        padding: 0 4px;\n        border-radius: 6px;\n        font-size: 14px;\n        white-space: nowrap;\n      }\n    }\n\n    .axissaMobile {\n      @include respond-md {\n        margin-top: 20px;\n        gap: 10px;\n\n        .headerMenuSection {\n          width: 28px;\n          height: 28px;\n          border-radius: 4px;\n          padding: 6px;\n\n          svg {\n            width: 16px;\n            height: 16px;\n          }\n        }\n\n        .menuOption {\n          width: 28px;\n          height: 28px;\n          border-radius: 4px;\n          padding: 6px;\n\n          svg {\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n    }\n\n    .authenticatedWebViewOption {\n      display: flex;\n      gap: 14px;\n\n      @include respond-md {\n        display: none;\n      }\n\n      .dropDownBody {\n        background-color: $bg-light-grey-2;\n        display: flex;\n        align-items: flex-start;\n        gap: 16px;\n        font-size: 18px;\n        font-family: var(--primary-font, 'Inter', sans-serif);\n        border: 1px solid $color-border-primary-grey;\n        border-top-left-radius: 20px;\n        border-top-right-radius: 20px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        user-select: none;\n        width: 308px;\n        padding: 16px;\n\n        @include respond-md {\n          width: 100%;\n          max-width: 1200px;\n          margin: 0 auto;\n          padding: 16px 20px;\n        }\n\n        .imageContainer {\n          display: flex;\n          flex-direction: column;\n          text-wrap: wrap;\n\n          .font_600 {\n            color: var(--theme-default-text-color);\n          }\n        }\n\n        .profileDropdown {\n          padding: 0;\n        }\n\n        .dropDownBodyContainer {\n          display: flex;\n          flex-direction: column;\n          gap: 24px;\n          font-family: var(--primary-font, 'Inter', sans-serif);\n          font-weight: 600;\n          font-size: 16px;\n          padding: 24px;\n\n          @include respond-md {\n            gap: 16px;\n            padding: 24px 20px;\n            width: 100%;\n            max-width: 1200px;\n            margin: 0 auto;\n          }\n\n          .showTabModule {\n            display: none;\n\n            @include respond-md {\n              display: block;\n            }\n          }\n\n          .bodyContainer {\n            align-items: flex-start;\n            gap: 8px;\n            cursor: pointer;\n            position: relative;\n            border-radius: 10px;\n            display: none;\n\n            @include respond-md {\n              display: flex;\n            }\n\n            .image {\n              width: 24px;\n              height: 24px;\n              object-fit: contain;\n            }\n\n            .cardHeader {\n              font-weight: 500;\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              width: 100%;\n            }\n\n            .showDropdown {\n              position: absolute;\n              top: 100%;\n              left: 0;\n              z-index: 50;\n              margin-top: 8px;\n              width: 100%;\n              height: 175px;\n              overflow-y: auto;\n              background-color: $color-white;\n\n              .cardItem {\n                padding: 8px;\n                font-size: 14px;\n                cursor: pointer;\n\n                &:hover {\n                  background-color: $bg-light-grey-2;\n                }\n              }\n            }\n          }\n\n          .loyaltyPoint {\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n            cursor: pointer;\n            padding-right: 16px;\n          }\n\n          .logout:hover {\n            border-bottom-left-radius: 20px;\n            border-bottom-right-radius: 20px;\n            cursor: pointer;\n          }\n        }\n      }\n\n      &.showAuthenticated {\n        width: 35px;\n        height: 35px;\n\n        .header {\n          width: 35px;\n          height: 35px;\n        }\n      }\n\n      &.hideAuthenticated {\n        width: auto;\n      }\n\n      .buttonText {\n        height: auto;\n        width: auto;\n        font-size: 14px;\n        font-weight: 500;\n        padding: 8px 16px;\n      }\n    }\n  }\n\n  .dropDownBody {\n    background-color: $bg-light-grey-2;\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    font-size: 18px;\n    font-family: var(--primary-font, 'Inter', sans-serif);\n    border: 1px solid $color-border-primary-grey;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    user-select: none;\n    width: 308px;\n    padding: 16px;\n\n    @include respond-md {\n      width: 100%;\n      max-width: 1200px;\n      margin: 0 auto;\n      padding: 16px 20px;\n    }\n\n    .imageContainer {\n      display: flex;\n      flex-direction: column;\n      text-wrap: wrap;\n\n      .font_600 {\n        color: var(--theme-default-text-color);\n      }\n    }\n\n    .profileDropdown {\n      padding: 0;\n    }\n  }\n\n  .dropDownBodyContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    font-family: var(--primary-font, 'Inter', sans-serif);\n    font-weight: 600;\n    font-size: 16px;\n    padding: 24px;\n\n    @include respond-md {\n      gap: 12px;\n      padding: 20px;\n      width: 100%;\n      max-width: 1200px;\n      margin: 0 auto;\n      font-size: 14px;\n    }\n\n    .showTabModule {\n      display: none;\n\n      @include respond-md {\n        display: block;\n      }\n    }\n\n    .bodyContainer {\n      align-items: flex-start;\n      gap: 8px;\n      cursor: pointer;\n      position: relative;\n      border-radius: 10px;\n      display: none;\n\n      @include respond-md {\n        display: flex;\n      }\n\n      .image {\n        width: 24px;\n        height: 24px;\n        object-fit: contain;\n      }\n\n      .cardHeader {\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n      }\n\n      .showDropdown {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        z-index: 50;\n        margin-top: 8px;\n        width: 100%;\n        height: 90px;\n        overflow-y: auto;\n        background-color: $color-white;\n\n        @include respond-md {\n          height: 75px;\n          border-radius: 12px;\n        }\n\n        .cardItem {\n          padding: 4px 8px;\n          font-size: 14px;\n          font-weight: 400;\n          cursor: pointer;\n\n          &:hover {\n            background-color: $bg-light-grey-2;\n          }\n        }\n      }\n    }\n\n    .loyaltyPoint {\n      display: flex;\n      justify-content: space-between;\n      width: 100%;\n      cursor: pointer;\n      padding-right: 16px;\n    }\n\n    .offlineCacheButton {\n      background: transparent;\n      border: 0;\n      color: inherit;\n      cursor: pointer;\n      font: inherit;\n      font-weight: 600;\n      padding: 0;\n      text-align: left;\n    }\n\n    .offlineCacheButton:hover {\n      text-decoration: underline;\n    }\n\n    .logout:hover {\n      border-bottom-left-radius: 20px;\n      border-bottom-right-radius: 20px;\n      cursor: pointer;\n    }\n  }\n  \n  // Login component wrapper\n  .loginComponentWrapper {\n    max-width: 1200px;\n    padding: 0 20px;\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n    justify-content: flex-end;\n\n    @include respond-md {\n      justify-content: center;\n    }\n\n    .authDrawerContainer {\n      position: absolute;\n      top: 80px;\n      z-index: 30;\n      max-width: 448px;\n      max-height: calc(100vh - 104px);\n      margin-left: auto;\n      margin-right: auto;\n      overflow-y: auto;\n      overscroll-behavior: contain;\n      scrollbar-gutter: stable;\n      width: 100%;\n\n      @include respond-md {\n        max-width: calc(100vw - 0px);\n        left: 0px;\n        right: 0px;\n      }\n    }\n  }\n\n  // Sign up component wrapper\n  .signUpComponentWrapper {\n    margin-top: 8px;\n    padding: 0 20px;\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n    justify-content: flex-end;\n\n    @include respond-md {\n      justify-content: center;\n    }\n\n    .signUpContainer {\n      position: absolute;\n      z-index: 30;\n      max-width: 448px;\n      margin-left: auto;\n      margin-right: auto;\n\n      @include respond-md {\n        max-width: $breakpoint-md;\n      }\n    }\n  }\n}\n\n.tabModuleSection {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 4px;\n\n  @include respond-md {\n    gap: 10px;\n    flex-direction: column;\n  }\n\n  @keyframes pulse {\n    50% {\n      opacity: .5;\n    }\n  }\n  .animatePulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    height: 40px;\n    width: 80px;\n    background-color: $bg-light-grey-2;\n    border-radius: 8px;\n  }\n\n  .moduleTabButton {\n    padding: 4px 8px;\n    width: max-content;\n    cursor: pointer;\n    // font-weight: 500;\n    border-radius: 4px;\n    background-color: var(--moduleTabButtonBackground);\n    color: var(--moduleTabButtonColor);\n    border-color: var(--moduleTabButtonBorderColor);\n    // &.active {\n    //   font-weight: 600;\n    // }\n  }\n}\n\n.dropdownHeaderWrapper {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  background-color: $bg-light-grey-2;\n  padding: 4px 8px;\n  border-radius: 4px;\n  gap: 8px;\n  position: relative;\n  cursor: pointer;\n\n  @include respond-md {\n    display: none;\n  }\n\n  .headerDropdown {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    .headerDropdownLogo {\n      width: 24px;\n      height: 24px;\n      object-fit: contain;\n    }\n\n    .headerText {\n      font-family: var(--primary-font, 'Inter', sans-serif);\n      font-size: 12px;\n      font-weight: 500;\n      \n      @include respond-xxlg {\n        font-size: 10px;\n      }\n    }\n  }\n}\n\n.dropdownBody {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 50;\n  margin-top: 8px;\n  width: 100%;\n  max-height: 110px;\n  overflow-y: auto;\n  background-color: $color-white;\n  border: 1px solid $color-border-primary-grey;\n  border-radius: 6px;\n  box-shadow: 0 10px 15px $color-border, 0 4px 6px rgba($color-black, 0.05);\n\n  .cardInfo {\n    padding: 8px;\n    font-size: 12px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: $bg-light-grey-2;\n    }\n  }\n}\n","@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n","// ====================================\n// 🎨 Color Variables\n// ====================================\n\n$color-white: #ffffff;\n$color-black: #000000;\n\n// Primary Colors\n$color-primary-pink: #EA2466;\n$color-secondary-pink: #F5437E;\n$color-primary-dark-grey: #383838;\n$color-primary-medium-grey: #4a4a4a;\n$color-primary-light-grey: #808080;\n$color-border-primary-grey: #e2e8f0;\n// $color-border-primary-grey: #b4b4b4;\n$color-text-grey: #616161;\n\n// Background Colors\n$bg-pink-10: #FDECF2; // approximated 10% of #EA2466\n$bg-white: #FFFFFF;\n$bg-light-grey-1: #E8E8E8;\n$bg-light-grey-2: #F7F7F7;\n$bg-light-grey-3: #EDEDED;\n\n// Misc Colors\n$color-green: #00A664;\n$color-yellow: #FECE00;\n$color-red: #EB0000;\n$border-color-light-grey: #DCDCDC;\n\n// Stroke Colors\n$stroke-pink: #E11F60;\n$stroke-black: #000000;\n$stroke-dark: #1E1E1E;\n$stroke-grey: #E5E5E5;\n\n// Hover Colors\n$hover-pink: #CB104E;\n$hover-dark-grey: #484848;\n// $hover-light-grey: #EDEDED;\n\n// ====================================\n// ****** Precious Metals Theme *******\n// ====================================\n\n// Base Colors--\n$color-foreground: #252525;\n$color-primary: #030213;\n$color-secondary: #f2f1fc;\n$color-muted: #ececf0;\n$color-muted-foreground: #717182;\n$color-accent: #e9ebef;\n$color-destructive: #d4183d;\n$color-border: rgba(0, 0, 0, 0.1);\n$color-input: transparent;\n$color-input-background: #f3f3f5;\n$color-switch-background: #cbced4;\n$color-ring: #b50000;\n\n// Chart Colors--\n$chart-1: #f18b00;\n$chart-2: #3a9ac3;\n$chart-3: #6d91db;\n$chart-4: #f2ab00;\n$chart-5: #f9a800;\n\n// Gray Scale--\n$color-gray-50: #f9fafb;\n$color-gray-100: #f3f4f6;\n$color-gray-200: #e5e7eb;\n$color-gray-300: #d1d5db;\n$color-gray-400: #9ca3af;\n$color-gray-500: #6b7280;\n$color-gray-600: #4b5563;\n$color-gray-700: #374151;\n$color-gray-800: #1f2937;\n$color-gray-900: #111827;\n$color-gray-950: #030712;\n\n// Gold Colors\n$color-gold-50: #fffbeb;\n$color-gold-100: #fef3c7;\n$color-gold-200: #fde68a;\n$color-gold-300: #fcd34d;\n$color-gold-400: #fbbf24;\n$color-gold-500: #f59e0b;\n$color-gold-600: #d97706;\n$color-gold-700: #b45309;\n$color-gold-800: #92400e;\n$color-gold-900: #78350f;\n\n// Silver Colors\n$color-silver-50: #f8fafc;\n$color-silver-100: #f1f5f9;\n$color-silver-200: #e2e8f0;\n$color-silver-300: #cbd5e1;\n$color-silver-400: #94a3b8;\n$color-silver-500: #64748b;\n$color-silver-600: #475569;\n$color-silver-700: #334155;\n$color-silver-800: #1e293b;\n$color-silver-900: #0f172a;\n\n// Blue Colors\n$color-blue-50: #eff6ff;\n$color-blue-100: #dbeafe;\n$color-blue-200: #bfdbfe;\n$color-blue-300: #93c5fd;\n$color-blue-400: #60a5fa;\n$color-blue-500: #3b82f6;\n$color-blue-600: #2563eb;\n$color-blue-700: #1d4ed8;\n$color-blue-800: #1e40af;\n$color-blue-900: #1e3a8a;\n\n// Green Colors (Additional to system green)\n$color-green-50: #f0fdf4;\n$color-green-100: #dcfce7;\n$color-green-200: #bbf7d0;\n$color-green-300: #86efac;\n$color-green-400: #4ade80;\n$color-green-500: #22c55e;\n$color-green-600: #00A664;\n$color-green-700: #15803d;\n$color-green-800: #166534;\n$color-green-900: #14532d;\n\n// Red Colors (Additional to system red)\n$color-red-50: #fef2f2;\n$color-red-100: #fee2e2;\n$color-red-200: #fecaca;\n$color-red-300: #fca5a5;\n$color-red-400: #f87171;\n$color-red-500: #ef4444;\n$color-red-600: #EB0000;\n$color-red-700: #b91c1c;\n$color-red-800: #991b1b;\n$color-red-900: #7f1d1d;\n\n// Purple Colors\n$color-purple-50: #f5f3ff;\n$color-purple-100: #f3e8ff;\n$color-purple-200: #e9d5ff;\n$color-purple-300: #d8b4fe;\n$color-purple-400: #c084fc;\n$color-purple-500: #a855f7;\n$color-purple-600: #9333ea;\n$color-purple-700: #7c3aed;\n$color-purple-800: #6b21a8;\n$color-purple-900: #581c87;\n\n// Indigo Colors\n$color-indigo-50: #eef2ff;\n$color-indigo-100: #e0e7ff;\n$color-indigo-200: #c7d2fe;\n$color-indigo-300: #a5b4fc;\n$color-indigo-400: #818cf8;\n$color-indigo-500: #6366f1;\n$color-indigo-600: #4f46e5;\n$color-indigo-700: #4338ca;\n$color-indigo-800: #3730a3;\n$color-indigo-900: #312e81;\n\n// yellow Colors\n$color-yellow-50: #fefce8;\n$color-yellow-100: #fef9c3;\n$color-yellow-200: #fef08a;\n$color-yellow-300: #fde047;\n$color-yellow-400: #facc15;\n$color-yellow-500: #eab308;\n$color-yellow-600: #ca8a04;\n$color-yellow-700: #a16207;\n$color-yellow-800: #854d0e;\n$color-yellow-900: #713f12;\n\n// Orange Colors\n$color-orange-50: #fff7ed;\n$color-orange-100: #ffedd5;\n$color-orange-200: #fed7aa; \n$color-orange-300: #fdba74;\n$color-orange-400: #fb923c;\n$color-orange-500: #f97316;\n$color-orange-600: #ea580c;\n$color-orange-700: #c2410c;\n$color-orange-800: #9a3412;\n$color-orange-900: #7c2d12;\n\n// pink Colors\n$color-pink-50: #fdf2f8;\n$color-pink-100: #fce7f3;\n$color-pink-200: #fbcfe8;\n$color-pink-300: #f9a8d4;\n$color-pink-400: #f472b6;\n$color-pink-500: #ec4899;\n$color-pink-600: #db2777;\n$color-pink-700: #be185d;\n$color-pink-800: #9d174d;\n$color-pink-900: #831843;\n","// ====================================\n// 📱 Breakpoints\n// ====================================\n\n$breakpoint-sm: 575px;\n$breakpoint-md: 768px;\n$breakpoint-lg: 990px;\n$breakpoint-xlg: 1100px;\n$breakpoint-xxlg: 1200px;\n$breakpoint-xxxlg: 1300px;\n$breakpoint-max: 1440px;\n// USAGE\n// .button {\n//   background-color: $primary-pink;\n\n//   @include respond-md {\n//     font-size: 14px;\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
